import onSpotlightDismissedFromLV from '../actions/onSpotlightDismissedFromLV';
import { orchestrator } from 'satcheljs';
import { lazyShowNotification } from 'owa-notification-bar';
import { FeedbackRibbon, FeedbackCategory, FeedbackDialogParams } from 'owa-feedback';
import * as React from 'react';

const styles = require('./onSpotlightDismissedFromLV.scss');

orchestrator(onSpotlightDismissedFromLV, actionMessage => {
    lazyShowNotification.importAndExecute(
        'dismiss-spotlight-lv-notification',
        'MailModuleNotificationBarHost',
        '' /* contentText */,
        {} /* NotificationBarOptions */,
        () => {
            // Work Item 77854: Add localized strings (when strings are finalized)
            const feedbackCategories: FeedbackCategory[] = [
                { logString: "I'd completed the task", uiString: "I'd completed the task" },
                {
                    logString: "The message highlighted wasn't relevant",
                    uiString: "The message highlighted wasn't relevant",
                },
                {
                    logString: "I've replied to this message elsewhere",
                    uiString: "I've replied to this message elsewhere",
                },
                {
                    logString: "I don't like this feature",
                    uiString: "I don't like this feature",
                },
            ];

            // Work Item 77854: Add localized strings (when strings are finalized)
            const yesFeedbackDialogParams: FeedbackDialogParams = {
                buttonText: 'Leave feedback',
                categories: feedbackCategories,
                ghostText: 'Please add any extra comments here',
                invokeFeedbackDialog: true,
                title: 'Why is this message not important?',
            };

            const noFeedbackDialogParams: FeedbackDialogParams = {
                hideButton: true,
            };

            // Work Item 77854: Add localized strings (when strings are finalized)
            return (
                <FeedbackRibbon
                    feature={'Spotlight'}
                    hideNoButton={true}
                    noFeedbackDialogParams={noFeedbackDialogParams}
                    ribbonMessage={'Marked as not important'}
                    ribbonMessageClassName={styles.ribbonMessage}
                    yesFeedbackDialogParams={yesFeedbackDialogParams}
                />
            );
        }
    );
});
